module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAeAAAAABCAYAAAAGu30GAAAAK0lEQVR4AWM4fPRED/XxKH7/8WsDvfG7TdsmDW88ikfxKB6IsoU25eQoBgB/wYPuvkWO9AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grids/selfcare_left+main+rightcontainer.png
// module id = 349
// module chunks = 0